/**
 * 学员服务
 * 处理学员相关的 API 调用
 */

import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * 学员服务
 */
const studentService = {
  /**
   * 获取学员列表（分页）
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.per_page - 每页数量
   * @param {string} params.name - 姓名筛选
   * @param {string} params.grade - 年级筛选
   * @param {string} params.gender - 性别筛选
   * @param {string} params.student_type - 学员类型筛选
   * @param {string} params.sort_by - 排序字段
   * @param {string} params.sort_order - 排序方向 (asc/desc)
   * @returns {Promise<Object>}
   */
  async getList(params = {}) {
    return apiClient.get(API_ENDPOINTS.STUDENTS.LIST, {
      page: 1,
      per_page: 20,
      ...params,
    });
  },

  /**
   * 获取学员下拉列表（不分页）
   * @param {Object} params - 查询参数
   * @param {string} params.student_type - 学员类型筛选
   * @param {boolean} params.exclude_ended - 是否排除已结束学员
   * @returns {Promise<Array>}
   */
  async getDropdownList(params = {}) {
    return apiClient.get(API_ENDPOINTS.STUDENTS.DROPDOWN, params);
  },

  /**
   * 获取学员详情
   * @param {number} id - 学员 ID
   * @returns {Promise<Object>}
   */
  async getById(id) {
    return apiClient.get(API_ENDPOINTS.STUDENTS.DETAIL(id));
  },

  /**
   * 获取学员课程账户信息（余额等）
   * @param {number} id - 学员 ID
   * @returns {Promise<Array>}
   */
  async getAccounts(id) {
    return apiClient.get(API_ENDPOINTS.STUDENTS.ACCOUNTS(id));
  },

  /**
   * 创建学员
   * @param {Object} data - 学员数据
   * @returns {Promise<Object>}
   */
  async create(data) {
    return apiClient.post(API_ENDPOINTS.STUDENTS.CREATE, data);
  },

  /**
   * 更新学员
   * @param {number} id - 学员 ID
   * @param {Object} data - 更新数据
   * @returns {Promise<Object>}
   */
  async update(id, data) {
    return apiClient.put(API_ENDPOINTS.STUDENTS.UPDATE(id), data);
  },

  /**
   * 删除学员
   * @param {number} id - 学员 ID
   * @returns {Promise<Object>}
   */
  async delete(id) {
    return apiClient.delete(API_ENDPOINTS.STUDENTS.DELETE(id));
  },

  /**
   * 根据出生年月计算年级
   * @param {Object} data - 出生信息
   * @param {number} data.birth_year - 出生年份
   * @param {number} data.birth_month - 出生月份
   * @returns {Promise<Object>} { grade: string, age: number }
   */
  async calculateGrade(data) {
    return apiClient.post(API_ENDPOINTS.STUDENTS.CALCULATE_GRADE, data);
  },
};

export default studentService;
